module.exports = __webpack_public_path__ + "img/68400.ea668b97.jpg";